import ProfilePhotoPrompt from "../components/profile/ProfilePhotoPrompt";
import React from "react";
import Navigation from "./Navigation";
import { Container } from "react-bootstrap";
import AuthTopNav from "../pages/auth/AuthTopNav";

const Layout = ({ children, useAuthTopNav = false }) => {
  return (
    <>
      {useAuthTopNav ? <AuthTopNav /> : <Navigation />}
      <Container as="main" id="main-content" tabIndex={-1}>
        <ProfilePhotoPrompt />
        {children}
      </Container>
    </>
  );
};

export default Layout;
